/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from 'react';
import useActions from 'hooks/useActions';
import InformationTab from 'components/InformationTab';
import SingleFilter from 'components/SingleFilter';
import FlagsTable from './FlagsTable';
import TableNavigator from 'components/TableNavigator';
import TableResults from 'components/TableResults';
import {STATUS_OPTIONS, CREATED_SORTING_OPTIONS} from 'constants/COMMUNITY_STATUS';


const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {
        flags: state.CSFlags.flagList,
        isLoading: state.CSFlags.isLoading,
        per_page: state.CSFlags.per_page,
        page: state.CSFlags.page,
        total: state.CSFlags.total,
        total_pages: state.CSFlags.total_pages,
        statusFilter: state.CSFlags.statusFilter,
        sortingFilter: state.CSFlags.flagsOrder,
        selectedRegionFilter: state.user.selectedRegion,
    };
}

const CSFlags = connect(mapStateToProps)(function (props) {
    const {
        flags,
        isLoading,
        per_page,
        page,
        total,
        total_pages,
        statusFilter,
        sortingFilter,
        selectedRegionFilter,
    } = props;
    const {
        CS_FETCH_FLAGS_REQUEST,
        CS_SELECT_FLAGS_STATUS,
        CS_SELECT_FLAGS_ORDER_FILTER,
        CS_FLAGS_CHANGE_REASON_REQUEST,
    } = useActions();

    useEffect(() => {
        CS_FETCH_FLAGS_REQUEST({
            page,
            per_page,
            sorting: sortingFilter,
            status: statusFilter,
        });
    }, []);

    useEffect(() => {
        CS_FETCH_FLAGS_REQUEST({
            page,
            per_page,
            sorting: sortingFilter,
            status: statusFilter,
        });
    }, [sortingFilter,statusFilter, selectedRegionFilter]);

    function filters() {
        return [
            <SingleFilter
                options={[
                    { value: 'all', label: 'All statuses' },
                    ...STATUS_OPTIONS,
                ]}
                selectedValue={statusFilter}
                onSelect={(value) =>
                    CS_SELECT_FLAGS_STATUS(value)
                }
            />,
            <SingleFilter
                options={[
                    ...CREATED_SORTING_OPTIONS,
                ]}
                selectedValue={sortingFilter}
                onSelect={(value) =>
                    CS_SELECT_FLAGS_ORDER_FILTER(value)
                }
            />,
        ]
    }

    const onNextPage = () => {
        CS_FETCH_FLAGS_REQUEST({
            per_page,
            page: page + 1,
            sorting: sortingFilter,
            status: statusFilter,
        });
    }

    const onPrevPage = () => {
        CS_FETCH_FLAGS_REQUEST({
            per_page,
            page: page - 1,
            sorting: sortingFilter,
            status: statusFilter,
        });
    }
    const onPageSelect = (pageSelected) => {
        CS_FETCH_FLAGS_REQUEST({
            per_page,
            page: pageSelected,
            sorting: sortingFilter,
            status: statusFilter,
        });
    }

    const onPerPageSelected = ({ perPage }) => {
        CS_FETCH_FLAGS_REQUEST({
            per_page: perPage,
            page: page,
            sorting: sortingFilter,
            status: statusFilter,
        });
    }

    const handleChangeReason = (body) => {
        if(!body){
            return;
        }
        CS_FLAGS_CHANGE_REASON_REQUEST({
            body,
            page,
            per_page,
            sorting: sortingFilter,
            status: statusFilter,})
    }

    return (
        <section>
            <InformationTab
                sectionName="Flags"
                customFilters={filters()}
                dataTable={
                    <div>
                        <TableResults results={total} />
                        <FlagsTable
                            flags={flags}
                            isLoading={isLoading}
                            handleChangeReason={handleChangeReason}
                        />
                        <TableNavigator
                            currentPage={page}
                            totalPages={total_pages}
                            onNext={onNextPage}
                            onPrev={onPrevPage}
                            onPageSelected={onPageSelect}
                        />
                    </div>
                }
                showPrograms={false}
                showSearchField={false}
                perPage={per_page}
                onPerPageSelected={onPerPageSelected}
            />
        </section>
    );
});

export default CSFlags;
